import { useState } from "react";
import Reflux from "reflux";

import { COMPANY_ACTIVITY_CATEGORY_TO_LABEL } from "@javascript/constants/search/search_constants";
import { trackSearchFilterCategoryState } from "@javascript/helpers/searchFilterUtilities";

import Accordion from "@javascript/reactComponents/lds/accordion/Accordion";
import { AccordionContent } from "@javascript/reactComponents/lds/accordion/AccordionContent";
import { AccordionTrigger } from "@javascript/reactComponents/lds/accordion/AccordionTrigger";

import FacetSearchStore from "@javascript/stores/facetSearchStore";
import FilterItem from "@javascript/reactComponents/lds/FilterItem";
import Icon from "@javascript/reactComponents/lds/Icon";

function FacetSearchCompanyActivity({ data, nested = false }) {
  const { content, id, name, parent, tooltip, type, value } = data;
  const selected = FacetSearchStore.data.activities.selected === id;

  const hasNestedItems = !!content && content.length > 0;
  const anyChildrenSelected =
    content &&
    content.find(
      (child) => child.id === FacetSearchStore.data.activities.selected
    );

  const [open, setOpen] = useState(!!anyChildrenSelected || selected);
  const toggle = () => {
    trackSearchFilterCategoryState(!open, "company_activity");
    setOpen(!open);
  }

  // Special behaviour: Clicking label doesn't close it
  // after it has been opened once
  const handleSelect = (event) => {
    event.stopPropagation();

    if (!open && !nested && hasNestedItems) {
      setOpen(true);
    }

    FacetSearchCompanyActivityActions.activityToggled(id);
  };

  let trailingIcon;
  if (hasNestedItems) {
    trailingIcon = "chevron-" + (open ? "up" : "down") + "-centered";
  } else {
    trailingIcon = "placeholder";
  }

  const trailingContent = (
    <>
      <span id={id + "_count"}>{value && value !== "0" && value}</span>
      {/* Special behaviour: Trailing icon isn't shown for nested items, but should continue to occupy space... */}
      <Icon
        name={trailingIcon}
        style={{ visibility: hasNestedItems ? "visible" : "hidden" }}
      />
    </>
  );

  let disabled = false;

  // Business REQ: When user is viewing a feed, and the feed was created with a Company Activity selected,
  // then all other options must be disabled.
  // Old comment: this logic will fail if we get grandchildren or deeper... will need a superset tag:
  //              Zymewire.original_feed_query.category != this.props.element_data..superset
  if (
    Zymewire.original_feed_query &&
    typeof Zymewire.original_feed_query.category != "undefined"
  ) {
    disabled =
      Zymewire.original_feed_query.category !== "all_event" &&
      Zymewire.original_feed_query.category !== parent &&
      Zymewire.original_feed_query.category !== id;
  }

  const filterItem = (
    <FilterItem
      className={`companies_activity_entry ${id}_div`}
      expanded={open}
      label={name}
      leadingContent={<Icon name="radio" filled={selected} />}
      leadingContentClassName={"a_" + id}
      nested={nested}
      onLeadingContentClick={handleSelect}
      selected={selected}
      tooltip={tooltip}
      trailingContent={trailingContent}
      variant={
        COMPANY_ACTIVITY_CATEGORY_TO_LABEL[id] || COMPANY_ACTIVITY_CATEGORY_TO_LABEL[parent] || "other"
      }
      disabled={disabled}
    />
  );

  if (!hasNestedItems) {
    return filterItem;
  } else {
    return (
      <Accordion open={open}>
        <AccordionTrigger onClick={toggle}>{filterItem}</AccordionTrigger>
        <AccordionContent>
          {content.map((item) => (
            <FacetSearchCompanyActivity key={item.id} data={item} nested />
          ))}
        </AccordionContent>
      </Accordion>
    );
  }
}

// Default export uses createReactClass so we can listen to FacetSearchStore
export default createReactClass({
  mixins: [
    Reflux.listenTo(FacetSearchStore, function (data) {
      return data.activities;
    }),
  ],
  render() {
    return <FacetSearchCompanyActivity {...this.props} />;
  },
});
